module.exports = __webpack_public_path__ + "static/media/add-image.dc39c048.png";